import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { getServerUrl } from "../../config";
import axios from "axios";
import {
  Table,
  Space,
  Breadcrumb,
  Select,
  Input,
  Button,
  Row,
  Col,
  Tag,
} from "antd";

import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
const { Option } = Select;

class ClientList extends Component {
  constructor() {
    super();
  }
  state = {
    details: [],
    newdetails: [],
    data: [],
    process: [],
  };

  onChange = async (value) => {
    this.search(value);
  };
  componentDidMount() {
    axios
      .get(`${getServerUrl()}/client/clientlist`, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      })
      .then((res) => {
        let responsevalue = Object.values(res.data.data);
        const details = responsevalue;
        this.setState({ details });
      });
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  render() {
    const data = this.state.details;
    const dataDropDown = this.state.details;

    const columns = [
      {
        title: "Client Code",
        dataIndex: "client_code",
        key: "client_code",
        width: "20%",
        ...this.getColumnSearchProps("client_code"),
      },
      {
        title: "Client Name",
        dataIndex: "client_name",
        key: "client_name",
        width: "20%",
        ...this.getColumnSearchProps("client_name"),
      },
      {
        title: "Client Nick Name",
        dataIndex: "client_nick_name",
        key: "client_nick_name",
        width: "20%",
        ...this.getColumnSearchProps("client_nick_name"),
      },
      {
        title: "Client Code",
        dataIndex: "client_code",
        key: "client_code",
        width: "20%",
        ...this.getColumnSearchProps("client_code"),
      },
      {
        title: "Location",
        dataIndex: "city",
        key: "city",
        width: "20%",
        ...this.getColumnSearchProps("city"),
      },
      {
        title: "Phone No",
        dataIndex: "contact_number",
        key: "contact_number",
        width: "20%",
        ...this.getColumnSearchProps("contact_number"),
      },

      {
        title: "Action",
        dataIndex: "client_id",
        key: "client_id",
        render: (text, record) => (
          <Space size="middle">
            <NavLink to={"/edit-client/" + record.client_id}>
              View / Manage
            </NavLink>
          </Space>
        ),
      },
    ];

    return (
      <div>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item>Master Settings </Breadcrumb.Item>
          <Breadcrumb.Item>Client Settings</Breadcrumb.Item>
          <Breadcrumb.Item>Client List</Breadcrumb.Item>
        </Breadcrumb>
        <div
          className="site-layout-background"
          style={{ padding: 24, minHeight: 360 }}
        >
          <h2 className="titles">
            VIEW / MANAGE CLIENT <span>DATA</span>
          </h2>

          <Space></Space>
          <br />
          <Table columns={columns} dataSource={data}></Table>
        </div>
      </div>
    );
  }
}

export default ClientList;
